import { render, staticRenderFns } from "./EgdsEdit.vue?vue&type=template&id=2665e545"
import script from "./EgdsEdit.vue?vue&type=script&lang=js"
export * from "./EgdsEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports